/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FreeTrial,
    FreeTrialFromJSON,
    FreeTrialFromJSONTyped,
    FreeTrialToJSON,
} from './FreeTrial';

/**
 * 
 * @export
 * @interface GetFreeTrialResponse
 */
export interface GetFreeTrialResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetFreeTrialResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetFreeTrialResponse
     */
    message: string;
    /**
     * 
     * @type {FreeTrial}
     * @memberof GetFreeTrialResponse
     */
    data: FreeTrial;
}

export function GetFreeTrialResponseFromJSON(json: any): GetFreeTrialResponse {
    return GetFreeTrialResponseFromJSONTyped(json, false);
}

export function GetFreeTrialResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFreeTrialResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': FreeTrialFromJSON(json['data']),
    };
}

export function GetFreeTrialResponseToJSON(value?: GetFreeTrialResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': FreeTrialToJSON(value.data),
    };
}

